import messages from './colabora-modal-translations';
import * as $ from 'jquery';
import { ColaboraMapaService } from './services/colaboraMapaService';
import { ApplicationConstants } from '../../../shared/applicationConstants';

export default {
    name: 'instamapsColaboraModal',
    i18n: {
        messages,
    },
    data(){
        return {
            convidats: [],
            form: {
                email: "",
            }
        };
    },
    computed: {
        isDisabled: function(){
            if(this.convidats.length === 10){
                return true;    
            }else{
                return false;
            }
        },
        hasConvidats: function(){
            if(this.convidats.length > 0){
                return true;
            }else{
                return false;
            }
        },                
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        noPublicat: function(){
            if (this.mapa.dataConfiguracio === undefined ||
                this.mapa.dataConfiguracio === null || 
            ( this.mapa.dataConfiguracio === this.mapa.dataPublicacio)){
                return true;
            }
            else {
                return false;
            }
        },
        show: function () {
            if (!this.noPublicat()) {
                ColaboraMapaService.getConvidats(this.mapa.businessId).then((response) => {
                    if (response.status==="OK") {
                        var results = JSON.parse(response.results);
                        if (results===null){
                            this.convidats = [];
                        }
                        else {                        
                            this.convidats = results;
                        }
                        $('#colabora-modal').addClass('animate-flex-modal');
                    }else{
                        this.dismiss();
                        this.$emit('error', {title: this.$t('title'), message: this.$t('messageErrorLlistaConvidad')});
                    }
                }).catch(() => {
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageErrorLlistaConvidad')});
                });
            }
            else {
                $('#colabora-modal').addClass('animate-flex-modal');
            }
        },
        dismiss: function () {
            $('#colabora-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        convidarMapa: function(){
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.sendMail(this.form.email);
                }
            });
        },
        sendMail: function(to){
            let content = this.createEmailContent();
            let content2 = this.createEmailContent2();
            let esColaboratiu = 'S';
            let subject = this.$t('emailSubject');
            ColaboraMapaService.colaboraMap(this.mapa.businessId, to, subject, content, esColaboratiu, content2).then((response) => {
                if (response.status==="OK") {
                    let nouConvidat = {
                        email: to,
                        validat: 'N',
                    };
                    this.convidats.push(nouConvidat);
                    this.form.email = "";
                    window.dataLayer.push({
                        'event': 'convidats',
                        'businessid': this.mapa.businessId,
                        'num': this.convidats.length,
                        'tipus': 'add'
                    });
                }else{
                    self.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageErrorConvidad')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageErrorConvidad')});
            });
        },
        eliminarConvidat: function(item, index){
            ColaboraMapaService.eliminarConvidat(this.mapa.businessId, item.email).then((response) => {
                if (response.status==="OK") {
                    this.convidats.splice(index, 1);
                    window.dataLayer.push({
                        'event': 'convidats',
                        'businessid': this.mapa.businessId,
                        'num': this.convidats.length,
                        'tipus': 'remove'
                    });
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageErrorEliminarConvidad')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageErrorEliminarConvidad')});
            });
        },
        createEmailContent: function(){
            let content = '';
            content = this.$t('emailContent');
            content = content.replace(/\${nom}/, this.mapa.nomAplicacio);
            content = content.replace(/\${uid}/, this.mapa.entitatUid);
            content = content.replace(/\${mapaUrl}/,ApplicationConstants.baseCollaborationUrl+ ApplicationConstants.visorUrl + 'businessid='+this.mapa.businessId);
            return content;
        },
        createEmailContent2: function(){
            let content2 = '';
            content2 = '<br/><br/>'+this.$t('emailContent2');
            return content2;
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/colabora-modal/colabora-modal.js